<div id="main-navigation" class="vertical nav" [ngClass]="{'horizontal': layout === 'horizontal', 'vertical': layout === 'vertical'}">

  <ng-container *ngIf="layout === 'vertical'">
    <ng-container *ngFor="let item of navigationModel">
      <app-nav-collapse *ngIf="item.type == 'collapse'" [item]="item"></app-nav-collapse>
      <app-nav-group *ngIf="item.type == 'group'" [item]="item"></app-nav-group>
      <app-nav-item *ngIf="item.type == 'item'" [item]="item"></app-nav-item>
    </ng-container>
  </ng-container>


  <ng-container *ngIf="layout === 'horizontal'">
    <ng-container *ngFor="let item of navigationModel">
      <app-nav-horizontal-collapse *ngIf="item.type == 'collapse'" [item]="item"></app-nav-horizontal-collapse>
      <app-nav-horizontal-collapse *ngIf="item.type == 'group'" [item]="item"></app-nav-horizontal-collapse>
      <app-nav-horizontal-item *ngIf="item.type == 'item'" [item]="item"></app-nav-horizontal-item>
    </ng-container>
  </ng-container>

</div>